import React from 'react';
import './About.css';

const About = () => {
  return (
    <section id="about" className="about">
      <div className="about-content">
        <div className="about-image">
          <img
            src="/images/profile.png"
            alt="Portrait of photographer"
            className="portrait"
          />
        </div>
        <div className="about-text">
          <h2>About</h2>
          <p className="intro">
            By day, I work at the frontier of cybersecurity and AI strategy.
            The rest of the time, I'm a digital nomad chasing a simpler thesis.
          </p>
          <p>
            The best stories live in the people you meet along the way. With no fixed
            address, I travel the world capturing its faces, places, and unexpected
            detours, building creative community wherever the road sets me down.
          </p>
          <p>
            Every corner of this world holds stories waiting to be discovered,
            hidden in the weathered hands of a craftsman, the laughter echoing
            through ancient streets, the quiet resilience of communities shaped
            by history. Through my lens, I seek those moments where culture,
            humanity, and time intersect.
          </p>
          <div className="stats">
            <div className="stat">
              <span className="number">20+</span>
              <span className="label">Countries Explored</span>
            </div>
            <div className="stat">
              <span className="number">∞</span>
              <span className="label">Stories Waiting</span>
            </div>
            <div className="stat">
              <span className="number">0</span>
              <span className="label">Fixed Address</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;